import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, DatePicker, Form, Input, Row, Col, Popover } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
// import regIcon from 'assets/images/register-icon.svg';
import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import { RegistrationFormData } from 'contexts/registration/registrationFormData';
// import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { disabledDate } from 'utils';
// import { IconTitle } from 'components';
import { useLifeUserExist } from 'all-in-one-shared-api';
import PolicyAndMemberIdModal from '../../forget/PolicyAndMemberIdModal';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
// import { StyledTitle } from 'components/StyledTitle';
import ProgressSteps from '../components/ProgressSteps';
import moment from 'moment';
import { Typography } from 'antd';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import './lifeRegist.less';
import tanhao from 'assets/images/MakeRequest/tanhao.svg';
import Tab from '../../forget/component/Tab';
// import _get from 'lodash/get';
// import moment from 'moment';
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  padding-left: 200px;
  padding-right: 200px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const FormWrapper = styled.div`
  display: grid;
  row-gap: 12px;
  width: 550px;
  max-width: 100%;
  @media (max-width: 576px) {
    width: 350px;
    max-width: 100%;
  }
`;
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  max-width: 100%;
  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 100%;
  }
`;

function LifeRegistrationLandingPage() {
  const [errmessage, setErrmessage] = useState<string | null>(null);
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  // const initialValues = useRegistrationStateQuery();
  const [registrationState, setRegistrationState] = useState<RegistrationFormData>({});
  const { dispatch, setSelectFlag } = useContext(RegistrationFlowContext);
  // const [mobilePrefix, setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  // const dateFormat = DEFAULT_DATE_FORMAT;
  // const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const emailRef = React.useRef<InputRef>(null);
  const [selectType, setSelectType] = useState(0);
  const location = useLocation() as {
    state: {
      policyNumber: string;
      memberId: string;
      birthDate: string;
      memberType: '0';
      registNum?: boolean;
    };
  };
  const [form] = Form.useForm();
  const [randoms, setRandoms] = useState(0);
  const [errors, setErrors] = useState<string | null>(null);

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);
  const { data, error, shouldFetch, isLoading } = useLifeUserExist(
    'life-user-check' + randoms,
    {
      identityNo: registrationState.identityNo ?? '',
      birthDate: registrationState.dob ? moment(registrationState.dob).format('DD/MM/YYYY') : '',
      policyNumber: registrationState.policyNumber,
      customerType: selectType == 0 ? 'P' : 'C',
    },
    {
      onSuccess: (res) => {
        console.log(res);
      },
      onError: () => {
        // setStartLoading(false);
        // const message = setErrorCodeFun(err.code, i18n.language);
      },
    },
  );
  /* eslint-disable */
  useEffect(() => {
    console.log(location?.state?.registNum, 'location.state.registNum');
  }, [location]);
  useEffect(() => {
    if (data && !error) {
      //   setLoading(false);

      console.log('data', data);
      // 从 data 中提取 countryCode, email, mobile
      const countryCode = data.countryCode;
      const email = data.email;
      const mobile = data.mobile;
      const areaCode = data.areaCode ?? '';
      // 更新上下文
      dispatch({
        type: ActionType.UpdateFormData,
        payload: { countryCode, email, mobile, areaCode },
      });
      if (mobile || email) {
        navigate('/register/LifeRegistrationSubmission', {
          replace: true,
          state: {
            registNum: location?.state?.registNum,
          },
        });
      }
    } else if (error && error.code) {
      shouldFetch(false);
      //   setLoading(false);
      setErrors(error.code);
      const errorMessage = setErrorCodeFun(error.code, i18n.language);
      console.log('error', error);
      setErrmessage(errorMessage);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setErrmessage(message);
    }
  }, [navigate, data, error, dispatch, shouldFetch, i18n.language, errors]); // 监听 data 变化
  /* eslint-enable */
  useEffect(() => {
    setRandoms(Math.random());
    return () => {
      shouldFetch(false);
    };
  }, [shouldFetch]);
  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      setRandoms(Math.random());
      shouldFetch(true);
      event && event.preventDefault();
      dispatch({ type: ActionType.UpdateFormData, payload: data });
    },
    [shouldFetch, dispatch],
  );
  const onFinish = (/*values: RegistrationFormData*/) => {
    // dispatch({ type: ActionType.UpdateFormData, payload: values }); //提交时注释掉
    // navigate('/register/LifeRegistrationSubmission'); //提交时注释掉
    // setRegistrationState({
    //   identityNo: values.identityNo,
    //   dob: values.dob,
    // });
    onValidateSuccessful(registrationState);
  };
  const isValid =
    selectType == 0
      ? registrationState.identityNo?.trim() !== '' && registrationState.dob
      : registrationState.identityNo?.trim() !== '' && registrationState.policyNumber;
  // useEffect(() => {
  //   if (registrationState.identityNo && registrationState.dob) {
  //     onValidateSuccessful(registrationState);
  //   }
  // }, [registrationState, onValidateSuccessful]);
  // const handleChange = (value: string) => {
  //   setMobilePrefix(value);
  // };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  // const prefixSelector = <MobileNumberPrefix handleChange={handleChange} />;
  // const infoIcon = <InfoCircleOutlined style={{ cursor: 'pointer' }} onClick={showModal} />;

  return (
    // <div
    //   style={{
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'flex-start',
    //     justifyContent: 'center',
    //     backgroundColor: 'transparent',
    //   }}
    // >
    <ResponsiveContainer>
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
          border: '0',
        }}
        className="register-tab"
      >
        <ProgressSteps activeStepIndex={0} />

        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, border: 0 }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]} style={{ backgroundColor: 'white' }}>
            <Form
              // initialValues={initialValues}
              layout={'vertical'}
              requiredMark={false}
              onFinish={onFinish}
              form={form}
              validateTrigger={'onBlur'}
              style={{ width: '100%' }}
              onValuesChange={(changedValues) => {
                // 合并所有更改到 registrationState 中
                return setRegistrationState((prevState) => ({
                  ...prevState, // 保留之前的状态
                  ...changedValues, // 只更新 changedValues 中的字段
                }));
              }}
            >
              <FormWrapper>
                <Col
                  xs={24}
                  md={24}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}
                >
                  <Typography.Text
                    style={{ margin: '0 0 24px 0', fontSize: '26px', fontFamily: 'Roboto400', color: '#20252B' }}
                  >
                    {t('registration.lifeInsuranceTitle')}
                  </Typography.Text>
                  {/* <Divider /> */}
                </Col>
                <Col xs={24} md={24}>
                  <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                    {t('registration.lifemessage')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24}>
                  <Typography.Text style={{ color: '#752127', fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('forgetPassword.mandatoryMsg')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24}>
                  <Tab
                    values={[t('registration.individual'), t('registration.corporate')]}
                    selectedIndex={selectType}
                    onTabPress={(index) => {
                      form.resetFields();
                      setSelectFlag(index == 0 ? 'P' : 'C');
                      setErrmessage('');
                      setRegistrationState({});
                      setSelectType(index);
                    }}
                  />
                </Col>
                {selectType == 0 && (
                  <>
                    <Col xs={24} md={24} style={{ position: 'relative' }}>
                      <BoldLabelFormItem
                        label={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span
                              style={{
                                color: '#752127',
                                fontWeight: 'normal',
                                fontSize: '17px',
                                fontFamily: 'Roboto400',
                              }}
                            >
                              {t('registration.idOrPassport')}
                            </span>
                          </div>
                        }
                        name="identityNo"
                        rules={[{ required: true, message: t('registration.error.required') }]}
                        // tooltip={{ icon: infoIcon }}
                      >
                        <Input
                          size="middle"
                          // disabled={initialValues.isEmailRegister}
                          placeholder={t('registration.policyNumberHolder')}
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            // color: "white",
                            fontSize: '20px',
                            paddingLeft: 0,
                            backgroundColor: 'transparent',
                          }}
                        />
                      </BoldLabelFormItem>
                      <div style={{ position: 'absolute', top: 0, right: 20 }}>
                        <Popover
                          placement="topLeft"
                          content={
                            <div style={{ width: '350px' }}>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
                                {t('life.forgetLoginId.IdFormats')}
                              </p>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                                {t('life.forgetLoginId.HKID')}
                              </p>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                                {t('life.forgetLoginId.HKID2')}
                              </p>
                            </div>
                          }
                        >
                          <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                        </Popover>
                      </div>
                    </Col>
                    <Col xs={24} md={24}>
                      <BoldLabelFormItem
                        label={
                          <span
                            style={{
                              color: '#752127',
                              fontWeight: 'normal',
                              fontSize: '17px',
                              fontFamily: 'Roboto400',
                            }}
                          >
                            {t('registration.dobLabel')}*
                          </span>
                        }
                        name="dob"
                        rules={[{ required: true, message: t('registration.error.required') }]}
                      >
                        <DatePicker
                          className="customDatePicker"
                          disabledDate={disabledDate}
                          placeholder={t('common.placeholder.date')}
                          format="DD/MM/YYYY"
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            color: 'white',
                            backgroundColor: 'transparent',
                            width: '100%',
                            paddingLeft: 0,
                            fontSize: '20px',
                          }}
                        />
                      </BoldLabelFormItem>
                    </Col>
                  </>
                )}
                {selectType == 1 && (
                  <>
                    <Col xs={24} md={24} style={{ position: 'relative' }}>
                      <BoldLabelFormItem
                        label={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span
                              style={{
                                color: '#752127',
                                fontWeight: 'normal',
                                fontSize: '17px',
                                fontFamily: 'Roboto400',
                              }}
                            >
                              {t('registration.incorporation')}
                            </span>
                          </div>
                        }
                        name="identityNo"
                        rules={[{ required: true, message: t('registration.error.required') }]}
                        // tooltip={{ icon: infoIcon }}
                      >
                        <Input
                          size="middle"
                          // disabled={initialValues.isEmailRegister}
                          placeholder={t('registration.inplaceholder')}
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            // color: "white",
                            fontSize: '20px',
                            paddingLeft: 0,
                            backgroundColor: 'transparent',
                          }}
                        />
                      </BoldLabelFormItem>
                      <div style={{ position: 'absolute', top: 0, right: 20 }}>
                        <Popover
                          placement="topLeft"
                          content={
                            <div style={{ width: '350px' }}>
                              {/* <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
                                {t('life.forgetLoginId.IdFormats')}
                              </p>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                                {t('life.forgetLoginId.HKID')}
                              </p>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                                {t('life.forgetLoginId.HKID2')}
                              </p> */}
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
                                {t('registration.inTooltip')}
                              </p>
                            </div>
                          }
                        >
                          <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                        </Popover>
                      </div>
                    </Col>
                    <Col xs={24} md={24} style={{ position: 'relative' }}>
                      <BoldLabelFormItem
                        label={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span
                              style={{
                                color: '#752127',
                                fontWeight: 'normal',
                                fontSize: '17px',
                                fontFamily: 'Roboto400',
                              }}
                            >
                              {t('registration.policy')}
                            </span>
                          </div>
                        }
                        name="policyNumber"
                        rules={[{ required: true, message: t('registration.error.required') }]}
                        // tooltip={{ icon: infoIcon }}
                      >
                        <Input
                          size="middle"
                          maxLength={8}
                          // disabled={initialValues.isEmailRegister}
                          placeholder={t('registration.tplaceholder')}
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            // color: "white",
                            fontSize: '20px',
                            paddingLeft: 0,
                            backgroundColor: 'transparent',
                          }}
                        />
                      </BoldLabelFormItem>
                      <div style={{ position: 'absolute', top: 0, right: 20 }}>
                        <Popover
                          placement="topLeft"
                          content={
                            <div style={{ width: '350px' }}>
                              <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
                                {t('registration.pTooltip')}
                              </p>
                            </div>
                          }
                        >
                          <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                        </Popover>
                      </div>
                    </Col>
                  </>
                )}
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <BoldLabelFormItem style={{ width: '80%' }}>
                      {errmessage && (
                        <Alert
                          className="custom-alert"
                          message={errmessage}
                          type="error"
                          style={{
                            marginTop: 16,
                            border: 'none',
                          }}
                        />
                      )}
                      <Button
                        block
                        type="primary"
                        loading={isLoading}
                        disabled={!isValid}
                        style={{
                          marginTop: 24,
                          // maxWidth: '100%',
                          fontFamily: 'Roboto500',
                          fontSize: '20px',
                          height: '56px',
                          // width: '428px',
                        }}
                        size="large"
                        htmlType="submit"
                      >
                        {t('common.submit')}
                      </Button>
                    </BoldLabelFormItem>
                    {/*<Link
                      style={{
                        fontWeight: 'normal',
                        marginLeft: 4,
                        marginRight: 4,
                        color: '#C21B17',
                        textDecoration: 'underline',
                      }}
                      to="/forgot/login"
                      onClick={(e) => e.preventDefault()}
                    >
                      {t('forgetLoginId.help')}
                    </Link>*/}
                  </div>
                </Col>
              </FormWrapper>
            </Form>
          </Row>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default LifeRegistrationLandingPage;
